import React, { useState } from "react";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import Inbox from "@mui/icons-material/Inbox";
import HowToVote from "@mui/icons-material/HowToVote";
import InsertPhoto from "@mui/icons-material/InsertPhoto";
import Streetview from "@mui/icons-material/Streetview";

// core components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";


import OthelloBotonera from '../componentsothello/OthelloBotonera.jsx';
import { DataStatePage, TipoOthelloFieldGrid, Roles, PopUpResult } from "../othelloConstantes.jsx";
import OthelloGrid from '../componentsothello/OthelloGrid.jsx';
import OthelloEdit from '../componentsothello/OthelloEdit.jsx';
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData.jsx";

import ImageUpload from "../components/ImageUpload.jsx";
import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";

export default function Incidencias({ ...props }) {

    const { literal, idRol } = props;

    const [loading, setLoading] = React.useState(true);
    const [loadingtipos, setloadingtipos] = React.useState(true);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);

    const [dataincidencias, setdataincidencias] = React.useState(null);
    const [dataincidenciastipos, setdataincidenciastipos] = React.useState(null);

    const [alert, setalert] = React.useState(null);

    const [dataeditando, setdataeditando] = useState(null);
    const [indexeditando, setindexeditando] = useState(null);

    const [datatipoeditando, setdatatipoeditando] = useState(null);
    const [indextipoeditando, setindextipoeditando] = useState(null);

    React.useEffect(() => {

        setLoading(false);
        getDataPage();
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const getDataPage = () => {

        fetch('api/Data/GetTipoIncidencias')
            .then(response => response.json())
            .then(data => {
                setloadingtipos(false);
                setdataincidenciastipos(data);
            });

        fetch('api/Data/GetIncidencias')
            .then(response => response.json())
            .then(data => {
                setdataincidencias(data);
            });
    }

    const getDataVaciaTipo = () => {

        fetch('api/Data/GetTipoIncidenciaVacia')
            .then(response => response.json())
            .then(data => {
                setdatatipoeditando(data);
                setstatePage(DataStatePage.dsInsert);

            }).catch(error => {
                setdatatipoeditando(null);
            });;
    }

    const grabarDataPageTipo = (event) => {

        let formulario = document.getElementById('formtipoincidencia');
        let data = new FormData(formulario);

        fetch('api/Data/GrabarTipoIncidencia', {
            method: 'POST',
            body: data,

        }).then(response => response.json()).then(res => {

            if (indextipoeditando == -1) {

                var array = [...dataincidenciastipos];
                array.push(res);
                setdataincidenciastipos(array);
            }
            else {
                var array = [...dataincidenciastipos];
                array[indextipoeditando] = res;
                setdataincidenciastipos(array);
            }

            setindextipoeditando(null);
            setdatatipoeditando(null);

            setstatePage(DataStatePage.dsSearch);
            setalert(PopUpResult.OK);

        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPageTipo = () => {
        //LLama a obtener el idioma vacio, que es el que pondra el estado
        getDataVaciaTipo();
        setindextipoeditando(-1);
    }

    const buscarDataPageTipo = () => {
        setindextipoeditando(null);
        setdatatipoeditando(null);
        setstatePage(DataStatePage.dsSearch);
    }

    const cancelarDataPageTipo = () => {
        setindextipoeditando(null);
        setdatatipoeditando(null);
        setstatePage(DataStatePage.dsSearch);
    }

    const deshacerDataPageTipo = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indextipoeditando == -1)
            setstatePage(DataStatePage.dsSearch);
        //Sino, es que estabamos en un item valido
        //else
        //  this.forceUpdate()
    }

    //METODO SOBRE EL GRID    
    const editGridDataPageTipo = (valor, index) => {

        setindextipoeditando(index);
        setdatatipoeditando(valor);
        setstatePage(DataStatePage.dsEdit);
    }

    const deleteGridDataPageTipo = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_TipoInci);

            fetch('api/Data/EliminarTipoIncidencia', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {
                    //Si todo salie correcto limpio los valores de edicion
                    setindextipoeditando(index);
                    setdatatipoeditando(valor);

                    if (dataincidenciastipos != null) {
                        var array = [...dataincidenciastipos]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdataincidenciastipos(array);
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    const deleteGridDataPage = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Incidencia);

            fetch('api/Data/EliminarIncidencia', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {
                    //Si todo salie correcto limpio los valores de edicion
                    setdataeditando(valor);
                    setindexeditando(index);

                    if (dataincidencias != null) {
                        var array = [...dataincidencias]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdataincidencias(array);
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    const onclickColumna = (valor, field) => {
        if (field == "ubicacion") {
            if (valor != null && valor.lat != 0 && valor.lon != 0) {
                let uri = "https://www.google.com/maps?q=" + valor.lat + "," + valor.lon;

                window.open(uri, '_blank');
            }
        }
        else if (field == "imagen") {
            if (valor != null && valor.foto != null && valor.foto != '') {
                window.open(valor.foto, '_blank');

            }
        }
    }

    const onClosePopUpResult = () => {
        setalert("");
    }

    //METODOS DE RENDERIZADO DE LA PANTALLA

    function renderSearchTipos(datos) {

        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = idRol == Roles.SuperUsuario ? ["Tipo Incidencia", "Tipo", "Orden Visual", "Icono"] : ["Tipo", "Orden Visual", "Icono"];

        let valoreshow = idRol == Roles.SuperUsuario ? ["id_TipoInci", "tipo", "ordenVisual", "image"] : ["tipo", "ordenVisual", "image"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "image", items: [] });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} onEdit={editGridDataPageTipo} onDelete={deleteGridDataPageTipo} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={5} />);
    }

    function renderInsertEditTipos(tipo) {

        if (tipo != null) {
            let Nombre = tipo != null && tipo.id_TipoInci > 0 ? "Editar " + tipo.tipo : "Nuevo Tipo Incidencia";

            return (<OthelloTituloPanelData icon="inbox" titulo={Nombre} margentop={4}>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    <Grid container>
                        <Grid item xs={12} >
                            <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPageTipo} onGrabar={grabarDataPageTipo} onCancel={cancelarDataPageTipo} onDeshacer={deshacerDataPageTipo} />
                        </Grid>
                    </Grid>
                    <form id="formtipoincidencia" >
                        <Grid container>
                            <input id="Id_Oficina" name="Id_Oficina" type="hidden" value={tipo.id_Oficina} />
                            <input id="Id_TipoInci" name="Id_TipoInci" type="hidden" value={tipo.id_TipoInci} />
                            <input id="Idioma" name="Idioma" type="hidden" value={tipo.idioma} />
                            <Grid item xs={12} sm={2}>
                                <OthelloEdit label="Tipo" fieldname="Tipo" currentvalue={tipo.tipo} />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <OthelloEdit label="Orden Visual" fieldname="OrdenVisual" currentvalue={tipo.ordenVisual} />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={2}>
                                <legend>Icono (48x48px)</legend>
                                <ImageUpload
                                    id="Image" name="Image"
                                    imageUrl={tipo.image}
                                    addButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    changeButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    removeButtonProps={{
                                        color: "danger",
                                        round: true
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    function renderSearch(datos) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = ["", "", "Incidencia", "Tipo", "E-Mail", "Hora", "Foto", "Latitud", "Longitud", "Descripcion"];

        let valoreshow = ["ubicacion", "imagen", "nombre", "tipoInci", "eMail", "hora", "foto", "lat", "lon", "descripcion"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloDateTime, fieldname: "hora" });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "foto", items: [] });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "ubicacion", icon: Streetview, onclick: onclickColumna });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "imagen", icon: InsertPhoto, onclick: onclickColumna });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} onDelete={deleteGridDataPage} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={15} />);
    }

    let busquedaTipos = loadingtipos ? <p><CircularProgress color="secondary" /></p> : renderSearchTipos(dataincidenciastipos)

    let edicionTipos = statePage == DataStatePage.dsEdit || statePage == DataStatePage.dsInsert ? renderInsertEditTipos(datatipoeditando) : "";

    let busqueda = loading ? <p><CircularProgress color="secondary" /></p> : renderSearch(dataincidencias);

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    return (
        <Grid container>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    {alerta}
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    {edicionTipos}
                </Grid>
                <Grid container>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPageTipo} forzarnuevo={true} />
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <OthelloTituloPanelData tituloliteral="_tiposincidencias" margentop={1} backcoloretiqueta="#709e86">
                        <Grid container>
                            <Grid item xs={12} >
                                {busquedaTipos}
                            </Grid>
                        </Grid>
                    </OthelloTituloPanelData>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <OthelloTituloPanelData tituloliteral="_incidencias" margentop={3}>
                        <div style={{ backgroundColor: '#FFFFFF' }}>
                            <Grid container>
                                <Grid item xs={12} >
                                    {busqueda}
                                </Grid>
                            </Grid>
                        </div>
                    </OthelloTituloPanelData>
                </Grid>
            </Grid>
        </Grid>
    );
}

